import endpoints, { axios } from "../config/api";

function getAddableDependancyTasks(projectId: number, taskId: number) {
  return axios.get(
    endpoints.task.getAddableTaskDependancies(projectId, taskId)
  );
}

export default getAddableDependancyTasks;
